import { gql } from 'graphql-request';

export const GET_DISCOVERY_SETTINGS_LIST = gql`
  query getDiscoverySettingsList {
    getEASMProfiles {
      profileId
      organizationId
      profileName
      numIncludedSeeds
      numExcludedSeeds
      lastScan
      frequency
      scanStatus
    }
  }
`;
